<template>
  <base-stack class="user" v-if="user">
    <base-stack as="header" direction="column">
      <base-stack direction="row" justify="space-between" align="center">
        <base-stack direction="row" align="center" :spacing="4">
          <h2>{{ user.name || user.email }}</h2>
          <div v-if="user.blockedAt" class="blocked-badge">BLOCKED</div>
        </base-stack>
        <base-stack direction="row">
          <base-button :to="{ name: 'users' }">← Back to Users</base-button>
        </base-stack>
      </base-stack>
      <base-stack as="nav" direction="row">
        <base-button :to="{ name: 'user-info', params: { id } }">Info</base-button>
        <base-button :to="{ name: 'user-transactions', params: { id } }"
          >Transactions ({{ user.wallet.transactions.length }})
        </base-button>
        <base-button :to="{ name: 'user-shows', params: { id } }">Shows</base-button>
        <base-button :to="{ name: 'user-remarks', params: { id } }">Remarks ({{ user.remarks.length }})</base-button>
        <base-button :to="{ name: 'user-emails', params: { id } }">Emails</base-button>
        <base-button :to="{ name: 'user-comments', params: { id } }">Comments ({{ user.comments.length }})</base-button>
        <base-button :to="{ name: 'user-settings', params: { id } }">Settings</base-button>
      </base-stack>
    </base-stack>
    <router-view :user="user" />
  </base-stack>
</template>

<script lang="ts">
import { UserFragments } from '@/apollo/fragments/user';
import { User } from '@/types/api';
import gql from 'graphql-tag';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  apollo: {
    user: {
      query: gql`
        query User($id: ID, $email: String) {
          user(id: $id, email: $email) {
            ...User
          }
        }
        ${UserFragments.User}
      `,
      variables() {
        return { id: this.id };
      },
      fetchPolicy: 'network-only',
    },
  },
})
export default class UserView extends Vue {
  @Prop({ type: String, required: true }) public id!: string;

  user: User | null = null;
}
</script>

<style lang="scss" scoped>
.user {
  h2 {
    color: $color-theme-red;
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
  }

  header {
    padding: 1rem 0;
    border-bottom: 1px solid $color-theme-yellow;
  }

  .blocked-badge {
    background-color: $color-theme-red;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: bold;
    letter-spacing: 0.5px;
  }
}
</style>
